/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, { useEffect, useState } from 'react';
import { isEmpty } from 'services/global';
import { countdownToPreDraft, countdownToActualDraft } from 'services/timers';
import { useAuth } from 'providers/AuthProvider';
import { Link } from "react-router-dom";

const Home = () => {

    const authService = useAuth();
    const username = authService.getUsername();
    const token = authService.getToken();
    const [preDraftTimer, setPreDraftTimer] = useState('empty');
    const [actualDraftTimer, setActualDraftTimer] = useState('empty');

    useEffect(() => {
        document.title = "Youngster Keeper League";
    }, []);

    useEffect(() => {
        const countdownService = countdownToPreDraft();
        const countdownService2 = countdownToActualDraft();

        const subscription = countdownService.subscribe((preDraftTimer) => {
            setPreDraftTimer(preDraftTimer);
        });
        const subscription2 = countdownService2.subscribe((actualDraftTimer) => {
            setActualDraftTimer(actualDraftTimer);
        });

        return () => {
            subscription.unsubscribe();
            subscription2.unsubscribe();
        };
    }, [actualDraftTimer]);

    const openDraftWindow = () => {
        //REMINDER: make sure to change header.js if you change anything here
        return window.open(`/draft?token=${token}`, 'YKL_LIVE_DRAFT', `menubar=0,toolbar=0,location=0,status=1,resizable=1,scrollbars=1,noopener=0,height=${window.outerHeight},width=${window.outerWidth}`);
    }

    const hockey_season_months = [8, 9, 10, 11, 0, 1, 2, 3];

    return (
        <div>
            {(isEmpty(preDraftTimer) || preDraftTimer === 'empty') &&
                <h2 className="alert alert-main tac">Loading time until Draft Day...</h2>
            }
            {(!isEmpty(preDraftTimer) && preDraftTimer !== 'now' && preDraftTimer !== 'empty') &&
                <h2 className="alert alert-main tac">Draft Portal Opens in: {preDraftTimer}</h2>
            }
            {(preDraftTimer === 'now' && actualDraftTimer !== 'now' && actualDraftTimer !== 'completed' && !isEmpty(username)) &&
                <>
                    <h3 className="alert alert-main tac">
                        The draft portal is NOW OPEN! Time remaining until the live draft: <b>{actualDraftTimer}. </b>
                        <a onClick={() => openDraftWindow()} href="#">Click here</a> to go to the draft page.
                    </h3>
                </>
            }
            {(preDraftTimer === 'now' && actualDraftTimer !== 'now' && actualDraftTimer !== 'completed' && isEmpty(username)) &&
                <>
                    <h3 className="alert alert-main tac">
                        The draft portal is NOW OPEN! Time remaining until the live draft: <b>{actualDraftTimer}. </b>
                        Please <Link to="/login">login</Link> first to join in on the fun!
                    </h3>
                </>
            }
            {(actualDraftTimer === 'now' && !isEmpty(username)) &&
                <h3 className="alert alert-danger tac">
                    YOUR DRAFT IS CURRENTLY UNDER WAY! <a onClick={() => openDraftWindow()} href="#">Click here</a> to get into the draft!
                </h3>
            }
            {(actualDraftTimer === 'now' && isEmpty(username)) &&
                <h3 className="alert alert-danger tac">
                    YOUR DRAFT IS CURRENTLY UNDER WAY! Hurry, please <Link to="/login">login</Link> to be able to draft!
                </h3>
            }

            <h2>Information</h2>
            <ul>
                <li><b>$75 entry</b>. Winner gets $450, 2nd place gets $150.</li>
                <li>
                    {(() => {
                        const month = new Date().getMonth();
                        let draftStartYear;
                        let draftEndYear;
                        let undraftedYear;

                        if(hockey_season_months.includes(month)) {
                            draftStartYear = (month >= 8 && month <= 11) ? new Date().getFullYear() - 9 : new Date().getFullYear() - 10;
                            draftEndYear = (month >= 8 && month <= 11) ? new Date().getFullYear() : new Date().getFullYear() - 1;
                            undraftedYear = (month >= 8 && month <= 11) ? new Date().getFullYear() - 27 : new Date().getFullYear() - 28;
                        }
                        else {
                            draftStartYear = new Date().getFullYear() - 1;
                            draftEndYear = new Date().getFullYear() - 1;
                            undraftedYear = new Date().getFullYear() - 27;
                        }

                        return (
                            <>Drafts for skaters: {draftStartYear} - {draftEndYear}, including undrafted players who were born in {undraftedYear} or later.</>
                        );
                    })()}
                </li>
                <li>Goalies do not have any draft year restrictions (if you choose 2 goalies, they could be ages 34 and 36 if you want).</li>
                <li>Each team will have a roster of 15 players: <b>8FW, 2D, I UTIL, 1G, 3B</b>, with 3 IR+ positions when needed.</li>
                <li>Max moves per week: <b>5</b></li>
                <li>Goalie points are the following: <b>2P for a win, and an additional point for a shutout.</b> This points system
                    is reflected in total points for goalies on the Players/Live Draft page.</li>
            </ul>
            <h2>Playoffs</h2>
            <ul>
                <li>The top 6 teams make the playoffs. The top 2 teams get a bye to start playoffs.</li>
                <li>Playoff tiebreaker order is the following:
                    <ol>
                        <li>Team Points (Not total player points)</li>
                        <li>Team Wins</li>
                        <li>Head to head points vs the tied teams</li>
                        <li>Team points for (sum of points the team has scored throughout the entire season)</li>
                    </ol>
                </li>
                <li>Teams that didn't make the playoffs and eliminated teams will NOT be able to make any moves while playoffs are ongoing.</li>
                <li>Playoffs will be re-seeded after every round.</li>
            </ul>
        </div>
    );
}

export default Home;